import React, { Component, PropTypes } from 'react'
import Modal from 'react-modal'
import ReactGA from 'react-ga'

import CTAButton from '../CTAButton'
import './style.less'

class LeadForm extends Component {
	constructor(props) {
		super(props)
		this.state = {
			modalOpen: false,
			contactName: null,
			email: null,
			companyName: null,
			product: null,
			desc: null
		}
	}

	handleChange = (e) => {
		this.setState((state) => {
			const { name, value } = event.target
			return { [name]: value }
		})
	}

	handleOpenModal = () => {
		this.setState({ modalOpen: true })
		ReactGA.event({
			category: 'LeadForm',
			action: 'Open'
		})
	}

	handleCloseModal = () => {
		this.setState({ modalOpen: false })
	}

	handleSubmit = (e) => {
		e.preventDefault()
		const {
			contactName,
			email,
			companyName,
			product,
			desc
		} = this.state

		try {
			ReactGA.event({
				category: 'LeadForm',
				action: 'Submit'
			})

			if (email) {
				var referer = window.location.toString();
				var ref = firebase.database().ref().child('mailqueue').push();

				ref.set({
					contactName,
					email,
					companyName,
					product,
					desc,
					referer,
					when: firebase.database.ServerValue.TIMESTAMP
				});

				ReactGA.event({
					category: 'LeadForm',
					action: 'Success'
				})

				this.handleCloseModal()
			} else {
				ReactGA.event({
					category: 'LeadForm',
					action: 'Invalid'
				})
			}
		} catch(e) {
			ReactGA.event({
				category: 'LeadForm',
				action: 'Error',
				label: e.toString()
			})
		}
	}

	render() {
		const { ctaLabel, ctaMini, ctaVariation, product } = this.props
		const { modalOpen } = this.state
		return (
			<div>
				<CTAButton label={ctaLabel} variation={ctaVariation} mini={ctaMini} onClick={this.handleOpenModal} />
				<Modal
				 isOpen={modalOpen}
				 shouldCloseOnOverlayClick={true}
				 onRequestClose={this.handleCloseModal}
				 contentLabel=""
				 style={{
				  content : {
				    top                        : '10px',
				    left                       : '10px',
				    right                      : '10px',
				    bottom                     : '10px'
				  }
				}}
				>
					<button className="close-modal" onClick={this.handleCloseModal}>X</button>
					<form className="pure-form pure-form-stacked" onSubmit={this.handleSubmit}>
						<fieldset>
							<legend>Tell us about yourself</legend>
							<div className="row">
								<div className="col-sm-6 col-xs-12">
									<label htmlFor="contact-name">Your Name <small>Required</small></label>
									<input id="contact-name" name="contactName" type="text" required onChange={this.handleChange} />
								</div>

								<div className="col-sm-6 col-xs-12">
									<label htmlFor="email">E-Mail <small>Required</small></label>
									<input id="email" name="email" type="email" required onChange={this.handleChange} />
								</div>
							</div>
							<div className="row">
								<div className="col-xs-12">
									<label htmlFor="company-name">Company Name</label>
									<input id="company-name" name="companyName" type="text" onChange={this.handleChange} />
								</div>
							</div>
						</fieldset>
						<br /><br />
						<fieldset>
							<legend>Tell us what you're looking for</legend>
							<div className="row">
								<div className="col-xs-12">
									<label htmlFor="product">Which product are you interested in?</label>
									<select id="product" name="product" onChange={this.handleChange} defaultValue={product}>
										<option value="not-sure">I'm not sure</option>
										<option value="AC-75">AC-75</option>
										<option value="AC-75 C">AC-75 C</option>
										<option value="AC-220">AC-220</option>
										<option value="AC-230">AC-230</option>
										<option value="Magnum">Magnum</option>
										<option value="Magnum C">Magnum C</option>
									</select>
								</div>
								<div className="col-xs-12">
									<label htmlFor="desc">Tell us about your project</label>
									<textarea id="desc" name="desc" onChange={this.handleChange} />
								</div>
							</div>
							<br /><br />
							<center>
								<CTAButton submit={true} mini={false} variation="secondary" label="Yes, Contact Me" />
							</center>
						</fieldset>
					</form>
				</Modal>
			</div>
		)
	}
}

LeadForm.propTypes = {
	ctaLabel: PropTypes.node,
	ctaMini: PropTypes.bool,
	ctaVariation: PropTypes.string,
	product: PropTypes.string
}

LeadForm.defaultProps = {
	ctaLabel: "Contact Us",
	ctaMini: false,
	ctaVariation: null,
	product: null
}

export default LeadForm



// WEBPACK FOOTER //
// ../components/LeadForm/index.js